/* eslint import/prefer-default-export: "off" */

/**
 * Decodes a base64 string to a UTF-8 string.
 *
 * Sadly `atob` only works with ASCII strings, so the base64 string needs to be
 * converted to a binary string first.
 */
export function decodeBase64UTF8String(base64String) {
  const binaryString = atob(base64String);
  const bytes = new Uint8Array(binaryString.length);
  const chars = bytes.map((_, i) => binaryString.charCodeAt(i));
  return new TextDecoder().decode(chars);
}
